import React, { Component } from "react";
import withRouter from "../../withRouter";
import { Link } from "react-router-dom";
import Navigation from "../../components/Navigation";
import BasePage from "../../base/BasePage";
import { signOutUseCase } from "../../usecases/user";
import AboutUsPagePresenter from "./AboutUsPagePresenter";
import PortalSearch from "../../components/PortalSearch";
import Swipercarousel from "../../components/swipercarousel";
import Footer from "../../components/footer";
import Socials from "../../components/socialbottom";

class AboutUsPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new AboutUsPagePresenter(this, signOutUseCase());
  }

  logout() {
    this.presenter.onClickSignOut();
  }

  render() {
    const user = localStorage.getItem("user");

    return (
      <>
        <Navigation logout={this.logout.bind(this)} />
        <div className="col">
          <div style={{ marginTop: `6rem` }}>
            <div
              className="d-flex justify-content-center"
              style={{ alignItems: "center" }}
            >
              {/*Video Temporary Removed*/}
              {/* <video
                autoPlay
                loop
                playsInline
                preload="auto"
                className="img-fluid rounded-3 col-lg-9 col-md-10 col-10"
              >
                <source src="/HOME_PAGE_VIDEO.mp4" type="video/mp4" />
                <source src="/HOME_PAGE_VIDEO.webm" type="video/webm" />
              </video> */}
              {/* <video
                controls
                height="auto"
                className="img-fluid rounded-3 col-lg-9 col-md-10 col-10"
              >
                <source
                  src="https://vimeo.com/1061476820/28429ebce7?ts=0&share=copy"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video> */}
              {/* <iframe
                src="https://vimeo.com/1061476820/28429ebce7?ts=0&share=copy"
                width="80%"
                height="400"
                // className="img-fluid rounded-3 col-lg-9 col-md-10 col-10"
                allow="autoplay"
              ></iframe> */}

              <iframe
                src="https://player.vimeo.com/video/1061476820?h=28429ebce7&autoplay=1&loop=1&title=0&byline=0&portrait=0"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                width="80%"
                height="400"
                // title="HOME PAGE VIDEO"
              ></iframe>
            </div>
          </div>
          <div className="container-fluid text-center mt-5">
            <h1 className="fw-bold">
              Providing you the Best Service,
              <br />
              <span style={{ color: `#D18237` }}>
                <i>Just when you need it the most</i>
              </span>
            </h1>
            <div className="container-md px-4 py-3">
              <p className="fs-5 w-100 text-muted w-75">
                <b>LGS Staff Management Services Incorporated</b> is a high
                caliber professional manpower service provider for Hotels &
                Restaurant. We are recognized for our
                <b> quality and efficiency</b> in providing you the manpower,
                just when you need it the most.
              </p>
            </div>
            <div>
              <img
                className="rounded-3 shadow"
                src="/aboutus.jpg"
                style={{ height: "70%", width: "70%", objectFit: "cover" }}
              />
            </div>
          </div>
          {/* <div className="d-flex gap-3 w-100 p-5 col-sm-1 mb-5">
            <div className="col bg-white rounded-3" style={{ padding: `2rem` }}>
              <i
                className="bi bi-rocket"
                style={{ color: `#D18237`, fontSize: `4rem` }}
              ></i>
              <h1 className="fs-3 fw-bold">Our Mission</h1>
              <p className="fs-5 text-muted">
                To continuously STRIVE for EXCELLENCE and be effective manpower
                service provider of qualified, knowledgeable and highly
                competitive professionals in the Hotel and Restaurant industry.
              </p>
            </div>
            <div className="col bg-white rounded-3" style={{ padding: `2rem` }}>
              <i
                className="bi bi-eye"
                style={{ color: `#D18237`, fontSize: `4rem` }}
              ></i>
              <h1 className="fs-3 fw-bold">Our Vision</h1>
              <p className="fs-5 text-muted">
                To be the company of choice for our clients, jobseekers and
                employees. We strive to ensure quality service and endeavor to
                exceed expectation of those companies and individuals we deal
                with.
              </p>
            </div>
            <div className="col bg-white rounded-3" style={{ padding: `2rem` }}>
              <i
                className="bi bi-trophy"
                style={{ color: `#D18237`, fontSize: `4rem` }}
              ></i>
              <h1 className="fs-3 fw-bold">Our Goal</h1>
              <p className="fs-5 text-muted">
                To provide the local Hotel & Restaurant industry with workers
                who can share their expertise and their commitment to work. More
                so, to give the edge to compete locally with other companies.
              </p>
            </div>
          </div> */}
          <div className="container">
            <div className="row g-3 p-5">
              <div className="col-12 col-md-4">
                <div className="bg-white rounded-3 p-4 text-center shadow-sm">
                  <i
                    className="bi bi-rocket"
                    style={{ color: `#D18237`, fontSize: `4rem` }}
                  ></i>
                  <h1 className="fs-3 fw-bold mt-3">Our Mission</h1>
                  <p className="fs-5 text-muted">
                    To continuously STRIVE for EXCELLENCE and be an effective
                    manpower service provider of qualified, knowledgeable, and
                    highly competitive professionals in the Hotel and Restaurant
                    industry.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="bg-white rounded-3 p-4 text-center shadow-sm">
                  <i
                    className="bi bi-eye"
                    style={{ color: `#D18237`, fontSize: `4rem` }}
                  ></i>
                  <h1 className="fs-3 fw-bold mt-3">Our Vision</h1>
                  <p className="fs-5 text-muted">
                    To be the company of choice for our clients, jobseekers, and
                    employees. We strive to ensure quality service and endeavor
                    to exceed expectations of those companies and individuals we
                    deal with.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="bg-white rounded-3 p-4 text-center shadow-sm">
                  <i
                    className="bi bi-trophy"
                    style={{ color: `#D18237`, fontSize: `4rem` }}
                  ></i>
                  <h1 className="fs-3 fw-bold mt-3">Our Goal</h1>
                  <p className="fs-5 text-muted">
                    To provide the local Hotel & Restaurant industry with
                    workers who can share their expertise and their commitment
                    to work. More so, to give them the edge to compete locally
                    with other companies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <section>
          <div
            style={{
              // // position: "fixed",
              // bottom: "0",
              // left: "0",
              // right: "0",
              marginTop: "10px",
            }}
          >
            <Swipercarousel />
          </div>
        </section> */}

        <section>
          <Footer />
        </section>

        <Socials />
      </>
    );
  }
}

export default AboutUsPage;
